/**
 * Parse the space-separated UUID list from a citation link's
 * `data-highlight-ids="..."` attribute - the iframe/document format used by
 * Dictionary citations (e.g. SEC filings, and other retrieved-document
 * sources). Returns [] when the attribute is absent or empty.
 *
 * Shared by `sourceItems.ts` (render-side source filtering) and
 * `extractCitationIds.ts` (id matching for `filterCitationPayloadByIds`) so the
 * two stay in sync. Their divergence - the extractor never read
 * `data-highlight-ids` - was what dropped document-source citations on edit
 * turns.
 */
export function extractHighlightIdsFromLinkText(text: string | undefined): string[] {
  if (!text) return [];
  const match = text.match(/data-highlight-ids\s*=\s*("([^"]*)"|'([^']*)')/i);
  if (!match) return [];
  const raw = match[2] ?? match[3] ?? "";
  if (!raw.trim()) return [];
  return raw
    .split(/\s+/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}
